export interface SuccessStoryData {
  id: string;
  name: string;
  title: string;
  oneLiner: string;
  excerpt?: string;
  image: string;
  thumbnail?: string; // Added thumbnail field
  stats: {
    revenue?: string;
    employeeCount?: string;
    partners?: string;
    impact?: string;
  };
  size: 'small' | 'medium' | 'large';
  achieverId?: string; // Link to the achiever
  profileTitle?: string; // Added profile title property
  fullStory?: {
    title: string;
    highlightPhrase?: string;
    story: string[];
    quote?: string;
    hashtags?: string[];
  };
}

// Success stories data
export const successStories: SuccessStoryData[] = [

 {
  id: 'Rohit',
  name: 'Rohit Kumar Ch',
  title: 'From ₹18,000 to ₹20 Crores: How Rohit Built Infinite Interiors from the Ground Up',
  oneLiner: 'Designed by grit. Defined by detail.',
  excerpt: "Rohit started Infinite Interiors with just ₹18,000 and a sketchbook. Today, it’s a ₹20 crore interior design firm known for honest work, high-end projects, and quiet resilience.",
  image: '/Images/Rohit.jpg',
  thumbnail: '/Images/Rohit.jpg',
  stats: {
    revenue: '₹20+ Crore Business',
    impact: '368+ Projects | 80K+ Followers'
  },
  size: 'large',
  achieverId: 'custom-13',
  fullStory: {
    title: "From ₹18,000 to ₹20 Crores: The Infinite Interiors Story",
    highlightPhrase: "From Ground Up",
    story: [
      "Success stories are often told in numbers. But the ones that matter most—are told in moments. Moments of loss, grit, hunger, heartbreak, and quiet determination.",
      
      "This is the story of Rohit, the founder of Infinite Interiors (@infiniteinteriors98)—a Hyderabad-based interior design studio with 80K+ followers, a reputation for honest design, and a growing ₹20 crore business. But rewind a few years, and you’ll see a completely different frame.",
      
      "The Start: One Man. One Dream. ₹18,000 in Hand.",
      "No godfathers. No second chances. No cheat codes. Rohit arrived in Hyderabad in his early 20s with little more than a sketchbook of ideas and a dream that felt too big for his pocket. He took up his first project and earned just ₹18,000. It wasn’t much—but it was everything. It meant he was officially in the game.",
      "That tiny first paycheck didn’t just pay bills—it paid attention to his dream.",
      
      "The Fall: Losing It All—Twice",
      "The path wasn’t linear. It wasn’t easy. It wasn’t fair. He took risks. Trusted the wrong people. Faced betrayal. Faced burnout. Twice, he lost everything. Once to external circumstances. Once to internal collapse.",
      "There were nights when there was no bed. Days when there was no money. And weeks where the only thing keeping the company alive—was his will.",
      "But even then, Rohit refused to walk away. He rebuilt—not the same thing—but something stronger, clearer, more grounded.",
      
      "The Rise: Infinite Interiors is Born",
      "From chaos came clarity. Rohit decided to stop following trends and start trusting his taste. That’s how Infinite Interiors was born—a company not obsessed with looking luxury, but living authentically.",
      "Every project became a reflection of purpose. Every client interaction became a collaboration, not a transaction.",
      "Word spread—quietly but powerfully.",
      "Soon, Rohit was designing high-end residences, commercial spaces, cafes, concept homes. The boy who once took ₹18,000 projects was now leading a ₹20 crore design firm.",
      
      "The Philosophy: More Than Just Aesthetic",
      "Rohit’s design isn’t just about walls, floors, and ceilings. It’s about intent. About stories. About understanding how people live—and making space respond to that.",
      "He’s built a team that reflects this spirit: grounded, bold, diverse. Many of them weren’t given a chance anywhere else. Rohit gave them not just jobs—but purpose, trust, and belief.",
      
      "The Brand Today: Scaling Without Selling Out",
      "Today, Infinite Interiors is one of Hyderabad’s most trusted design studios. And it shows:",
      "• 80K+ organic followers on Instagram",
      "• 368+ completed projects",
      "• A ₹20 crore+ business with just two people followed—because the work does the talking",
      "This isn’t just design. It’s dedication. It's an ecosystem of grit, grace, and good taste—led by a founder who still sketches, still listens, still obsesses over the smallest detail.",
      
      "\"Being Young and Having Nothing—Were Never Reasons.\"",
      "It’s not a tagline. It’s Rohit’s truth. And it’s what powers Infinite Interiors.",
      "So the next time someone tells you your dreams are too big or your pockets are too small—send them this story.",
      
      "🔗 Follow the Journey:",
      "Company IG: @infiniteinteriors98",
      "Founder: @rohith_kumar_ch",
      "📍 Based in Hyderabad",
      "📞 Contact: 9110781058 | 7093681058"
    ],
    quote: "We didn’t build this brand with shortcuts. We built it with stories, second chances, and serious hustle."
  }
}
  , {
   
  id: 'B.M. Balakrishna',
  name: 'B.M. Balakrishna',
  title: 'From Repeated Failure to the Face of Clean Water in South India',
  oneLiner: 'Innovation, impact, and a mission-driven business that changes lives daily.',
  excerpt: "Balakrishna turned ₹1 lakh and a decade of experience into AQUAPOT — a ₹50+ crore clean water movement. From failed exams to water hero, his mission is proof that purpose can power profit.",
  image: '/Images/B.M. Balakrishna.png',
  thumbnail: '/Images/B.M. Balakrishna.png',
  stats: {
    revenue: '₹50+ Crore Revenue',
    impact: '30+ Franchises | 1000s Served'
  },
  size: 'large',
  achieverId: 'custom-16',
  fullStory: {
    title: "From Failure to ₹50 Cr: The Rise of South India’s Water Warrior",
    highlightPhrase: "Clean Water in South India",
    story: [
      "He failed the same subject six times. Worked at a local garage. Spent 10 years in a regular corporate job.",
      
      "And then, with ₹1 lakh in savings and a crystal-clear vision, Balakrishna decided to solve a problem millions were ignoring — access to clean, affordable drinking water.",
      
      "That decision gave birth to AQUAPOT, a company that not only delivers world-class water purifiers but also donates solar-powered RO plants to schools and hospitals in need.",
      
      "Balakrishna’s path was riddled with financial limitations, skepticism, and a lack of external funding. But he built AQUAPOT on three unshakable pillars:",
      "💧 Affordability without compromise",
      "💧 Decentralized franchise empowerment",
      "💧 Purpose over profit — always",
      
      "From low-cost maintenance models to direct community installations, his strategy blended business sense with social responsibility — creating a brand that thrives while giving back.",
      
      "Major milestones include:",
      "✅ Achieved ₹50+ Cr in revenue without venture capital",
      "✅ Established 30+ franchises across South India",
      "✅ Donated multiple solar-powered RO systems to underfunded schools and clinics",
      "✅ Created a reliable brand trusted by thousands of households",
      "✅ Built a reputation as the Water Warrior of South India",
      
      "Balakrishna didn’t chase spotlight — he created one by solving a real-world problem.",
      "Today, AQUAPOT isn’t just a product — it’s a promise of dignity, health, and sustainability."
    ],
    quote: "It doesn’t matter how many times you fall — only how many lives you lift when you rise."
  }
}
  , {
  id: 'Naveen Reddy',
  name: 'Kodudula Naveen Reddy',
  title: 'With Passionate Pocket Money, Setbacks Became Comebacks',
  oneLiner: 'Brewing more than chai — he’s brewing a legacy.',
  excerpt: "Naveen Reddy turned pocket money and passion into Mr. Irani — a multi-crore tea franchise that’s changing how India experiences chai. His journey shows how resilience can be steeped into every cup of success.",
  image: '/Images/Naveen Reddy.png',
  thumbnail: '/Images/Naveen Reddy.png',
  stats: {
    revenue: 'Multi-Crore Turnover',
    impact: 'Tea Franchise Movement'
  },
  size: 'large',
  achieverId: 'custom-15',
  fullStory: {
    title: "With Passionate Pocket Money: From Setbacks to Steaming Success",
    highlightPhrase: "Setbacks Became Comebacks",
    story: [
      "He didn’t wait for perfect timing. He didn’t rely on inherited wealth. He didn’t flinch at failure.",
      
      "Naveen Reddy started with little more than dreams and determination. While most saw tea as a roadside stall affair, he saw brand, experience, and community. That’s how Mr. Irani was born — with heart, hustle, and just enough money to brew the first batch.",
      
      "Today, his vision is steeped into every cup served across multiple cities — proving that greatness can be poured from the simplest kettles.",
      
      "Naveen’s story wasn’t linear. Two major business setbacks could have derailed him — but instead, they sharpened his resolve.",
      
      "His strategies were bold and customer-first:",
      "🍵 Introduced standardized Irani tea experience in a franchise model",
      "🍵 Leveraged regional nostalgia to build brand identity",
      "🍵 Focused on affordable pricing, high-footfall locations, and flavor consistency",
      "🍵 Created a franchise ecosystem that empowers small owners to scale",
      
      "Major milestones include:",
      "✅ Launched Mr. Irani, now a recognizable name in tea culture",
      "✅ Turned chai into a crore-turnover business",
      "✅ Expanded into multiple F&B sub-brands with loyal customer bases",
      "✅ Inspired a movement of young entrepreneurs choosing chai over corporate chains",
      "✅ Influences over 10K+ followers on Instagram and growing YouTube reach",
      
      "Naveen’s journey is a reminder that setbacks aren’t failures — they’re fuel. With just pocket money, he brewed not just tea, but trust, jobs, and joy.",
      
      "Today, Mr. Irani is more than a tea stop — it’s a symbol of entrepreneurship born from grit, not glamour."
    ],
    quote: "When life gave me setbacks, I boiled them with tea leaves and poured out success."
  }
}
  , {
  id: 'Uday',
  name: 'Uday',
  title: 'From 0 to Lakhs',
  oneLiner: 'Painting his way from rejection to recognition — one mural at a time.',
  excerpt: "Uday, founder of Uday Arts, turned blank walls into canvases of fame. From hand-painted corners to celebrity murals, he built a thriving brand that now inspires over 100K followers and employs young artists across South India.",
  image: '/Images/Uday.png',
  thumbnail: '/Images/Uday.png',
  stats: {
    revenue: '250+ Murals',
    impact: '108K+ Followers'
  },
  size: 'large',
  achieverId: 'custom-14',
  fullStory: {
    title: "From 0 to Lakhs: From Street Walls to Stardom",
    highlightPhrase: "Street Walls to Stardom",
    story: [
      "He didn’t wait for permission. He picked up a brush and painted his own path.",
      
      "Uday left home with nothing but passion, raw talent, and the courage to dream louder than the doubt around him. Once overlooked by many, he now brings life to blank walls across cities, earning praise from celebrities, influencers, and public figures alike.",
      
      "What began as small hand-painted art gigs slowly transformed into Uday Arts — a powerful personal brand known for mural magic, street vibrance, and emotion in every stroke.",
      
      "Uday’s early career was anything but glamorous. He faced skepticism, financial instability, and zero formal art exposure. What he lacked in resources, he made up for in hustle.",
      
      "📌 Painted on street corners, school walls, and cafés to build his portfolio",
      "📌 Leveraged Instagram reels and time-lapse content to go viral",
      "📌 Kept his focus on hand-crafted originality over digital shortcuts",
      
      "His breakthrough moment? A viral mural for a local café that caught the eye of influencers — launching a wave of commissions and collaborations.",
      
      "Major milestones include:",
      "✅ Built a loyal following of 108K+ on Instagram (@dayyy_arts)",
      "✅ Featured by celebrities and recognized by regional leaders",
      "✅ Completed 250+ wall murals across homes, offices, cafés, and studios",
      "✅ Runs a growing team of young artists under the Uday Arts brand",
      "✅ YouTube channel showcasing behind-the-scenes art process",
      
      "Uday’s journey is a masterclass in grit-led growth — proof that you don’t need degrees or connections to build a respected creative empire.",
      "Today, Uday Arts stands as one of the most followed independent muralist brands in South India, redefining street art and wall storytelling."
    ],
    quote: "When people said art can’t pay bills, I made my art pay salaries."
  }
},
    ,{
    id: 'Purushotham',
    name: 'Purushotham',
    title: 'From Bicycle to Brand',
    oneLiner: 'Turning doorstep hustle into a legacy silk retail brand',
    excerpt: "Purushotham, the founder of Nilambari Silk Store, transformed a sari-laden bicycle into a respected silk retail enterprise. His journey from door-to-door salesman to retail visionary is a tale of trust, tradition, and unshakable belief in cultural heritage.",
    image: '/Images/Purushotham.png',
    thumbnail: '/Images/Purushotham.png',
    stats: {
      revenue: '300+ Monthly Customers',
      impact: 'Legacy Retail Brand'
    },
    size: 'large',
    achieverId: 'custom-13',
    fullStory: {
      title: "From Bicycle to Brand: Weaving an Empire in Silk",
      highlightPhrase: "From Cycle to Showroom",
      story: [
        "What started as a one-man mission — cycling door to door with a bag of saris — evolved into Nilambari Silk Store, a symbol of trust, tradition, and transformation.",
      
        "Purushotham’s success was no accident. With no financial safety net or business background, he relied on grassroots sales, building his brand one sari, one household, and one conversation at a time. His core business philosophy: “Never sell fabric. Share culture.”",

        "With limited resources and zero digital reach in the early years, Purushotham's success hinged on consistency, connection, and community. His breakthroughs came from:",
        "• Offering at-home sari viewings for busy homemakers",
        "• Introducing pre-festival custom orders to align with customer preferences",
        "• Earning loyalty through word-of-mouth trust and transparent pricing",

        "As customer demand grew, so did his ambition. From a humble street vendor, he gradually scaled operations into a full-fledged retail store with an extensive inventory and loyal clientele.",

        "Major milestones include:",
        "✅ Transitioned from a mobile sari vendor to a brick-and-mortar showroom",
        "✅ Serves 300+ monthly walk-in customers and countless referrals",
        "✅ Built strong relationships with weavers for exclusive collections",
        "✅ Now exploring digital presence to reach younger audiences and NRIs",

        "Nilambari Silk Store stands as a living example that big brands don’t always begin with big budgets — they begin with belief. Today, the store is a go-to destination for traditional silk lovers, brides, and festive shoppers — driven not by hype, but by heritage and heart."
      ],
      quote: "It’s not the fabric that builds your brand. It’s the faith you weave into every customer interaction."
    }
  },
    {
    id: 'Bhanu-priya',
    name: 'Bhanu Priya',
    title: 'Tears Turned to 1Cr Turnover: journey of not just Survival but of Scale.',
    oneLiner: 'Building a ₹1 crore wholesale clothing business against all odds',
    excerpt: "Bhanu Priya transformed adversity into opportunity, scaling Amma Selection into a ₹1 crore wholesale clothing business. Her journey from personal struggles to entrepreneurial success showcases the power of resilience in the textile industry.",
    image: '/Images/Amma Selections.jpg',
    thumbnail: '/Images/Amma Selections.jpg',
    stats: {
      revenue: '₹1 Crore Annual Turnover',
      impact: 'Textile Industry Disruptor'
    },
    size: 'large',
    achieverId: 'custom-12',
    fullStory: {
      title: "Tears to Textiles: Bhanu Priya's 1Cr Wholesale Clothing Triumph",
      highlightPhrase: "Fabric to Fortune Transformation",
      story: [
        "Bhanu Priya's Amma Selection represents an extraordinary rags-to-riches story in the wholesale clothing sector. Starting with minimal resources, she built a ₹1 crore business by identifying gaps in the traditional textile supply chain.",

        "Her breakthrough came from recognizing underserved markets in tier 2/3 cities. Bhanu Priya pioneered a unique inventory model that combined affordable pricing with consistent quality - a rarity in wholesale clothing.",

        "Amma Selection's competitive edge lies in its three-pillar approach: 1) Direct sourcing from manufacturers 2) Strict quality checks 3) Flexible order quantities that accommodate small retailers. This trifecta disrupted traditional wholesale norms.",

        "The business saw exponential growth when Bhanu Priya digitized operations. Implementing an online catalog with real-time inventory boosted sales by 300% in one year, connecting her with retailers across 8 states.",

        "Key milestones include: Securing contracts with 50+ retail stores, launching private label collections, and establishing a 10,000 sq ft warehouse. Her 'small batch wholesale' model became an industry benchmark.",

        "Today, Amma Selection supplies to 120+ retailers nationwide while maintaining 45% profit margins. Bhanu Priya's journey proves that innovation and perseverance can rewrite traditional business narratives in the textile sector."
      ],
      quote: "In business as in fabrics - the strongest tapestries are woven one thread at a time. Never underestimate small beginnings.",
      hashtags: [
        "#WholesaleQueen",
        "#TextileEntrepreneur",
        "#ClothingBusiness",
        "#FashionSupplyChain",
        "#WomenInWholesale",
        "#ResilientEntrepreneur",
        "#1CrClub",
        "#B2BSuccess",
        "#InventoryInnovation",
        "#ManamuMedia",
        "#RetailRevolution",
        "#FabricOfSuccess",
        "#WholesaleInnovator",
        "#FromStruggleToScale",
        "#BusinessTurnaround"
      ]
    }
  },
  {
    id: 'anasuya Reddy',
    name: 'Anasuya Reddy',
    title: 'From Tailoring Challenges to Tech Triumph',
    oneLiner: 'Revolutionizing local tailoring with Run Tailor App',
    excerpt: "Anasuya Reddy transformed everyday tailoring challenges into an innovative tech solution with Run Tailor App. Her platform brings structure, scale and visibility to local tailors while providing customers with seamless service...",
    image: '/Images/Anasuya-Reddy.jpg',
    thumbnail: '/Images/Anasuya-Reddy.jpg',
    stats: {
      impact: 'Empowering Tailors',
      partners: 'Growing Network'
    },
    size: 'large',
    achieverId: 'custom-11',
    fullStory: {
      title: "From Tailoring Challenges to Tech Triumph: Anasuya's Journey with Run Tailor App",
      highlightPhrase: "Tailoring Challenges to Tech Triumph",
      story: [
        "Meet Anasuya, a dynamic influencer and community builder who transformed an everyday challenge into an innovative tech solution that's empowering thousands. As the founder of Run Tailor App, she's revolutionizing how local tailoring works across India by bridging the gap between traditional craftsmanship and modern technology.",

        "The spark for Run Tailor App came from a common frustration: delayed tailoring orders, poor communication, and lack of recognition for skilled tailors. Rather than seeing tailors as the problem, Anasuya recognized they were underserved - lacking digital presence, workflow management, and customer reach beyond their neighborhoods.",

        "Run Tailor App is more than just a scheduling tool - it's a comprehensive platform designed specifically for local tailors. The app helps them track orders, manage delivery timelines, communicate with customers, and maintain professional workflows. Most importantly, it gives tailors something they've never had before: digital dignity.",

        "What makes Anasuya's journey remarkable is her unique approach. Coming from a non-tech background, her strength lies in understanding people - their needs, frustrations, and aspirations. As an influencer, she had always used her voice to spotlight grassroots challenges. With Run Tailor App, she took that mission further by providing real tools for empowerment.",

        "Her development process was deeply collaborative - listening to tailors, testing features in live environments, and constantly refining the platform to meet real needs. This grassroots-first mindset has earned trust from hundreds of users as the app expands across cities and regions.",

        "Unlike typical tech ventures focused solely on growth, Anasuya's mission is clear: create meaningful impact while preserving the craft's soul. Her team works closely with tailoring communities, building partnerships with supply chains, training institutes, and women's self-help groups to create a supportive ecosystem.",

        "The impact is evident in every tailor who now manages their work efficiently, every customer who receives orders without anxiety, and every small shop transforming into a scalable business. Through Run Tailor App, Anasuya is stitching together a future where tradition and technology thrive together."
      ],
      quote: "Innovation doesn't require a tech background—just deep empathy, cultural insight, and the courage to act.",
      hashtags: ["#RunTailorApp", "#TechInnovation", "#LocalTailors", "#DigitalEmpowerment", "#ManamuMedia"]
    }
  },
    , {
    id: 'narasimha-reddy',
    name: 'Narasimha Reddy',
    title: 'Age Is Just a Number',
    oneLiner: 'Building a legacy brand with 7 branches and 450+ employees',
    excerpt: "Narasimha Reddy's journey with Mukunda Jewellers proves that age is never a barrier when vision meets perseverance. Starting later in life, he built a trusted jewellery empire focused on relationships and integrity...",
    image: '/Images/Narasimha-Reddy.jpg',
    thumbnail: '/Images/Narasimha-Reddy.jpg',
    stats: {
      employeeCount: '450+ Employees',
      impact: '7 Branches'
    },
    size: 'large',
    achieverId: 'custom-10',
    fullStory: {
      title: "Age Is Just a Number — Narasimha Reddy's Golden Legacy with Mukunda Jewellers",
      highlightPhrase: "Age Is Just a Number",
      story: [
        "In an age obsessed with youth and speed, some stories remind us that vision, patience, and purpose age like gold. Meet Narasimha Reddy, the man behind Mukunda Jewellers, whose extraordinary journey proves that age is not a limit—it's leverage.",

        "What started with nothing more than raw ambition and resilience has today blossomed into a powerful brand with 7 thriving branches and a workforce of over 450 employees. His is not just a story of business success—it's a story of belief, perseverance, and the timeless shine of trust.",

        "Narasimha Reddy wasn't born into wealth. There were no silver spoons or legacy showrooms waiting for him. His journey began like many great ones do—quietly, with hard work and hustle. In his early years, he took on odd jobs, observed people, and quietly absorbed the workings of the world around him. He wasn't rushing. He was learning.",

        "What set him apart was his unwavering vision. He believed in the value of relationships, in consistency, and in the elegance of simplicity. When he stepped into the jewellery business, it wasn't with grand declarations or fanfare—it was with a commitment to trust. And in this industry, trust is everything.",

        "From a modest store tucked away in a local market, Mukunda Jewellers grew brick by brick, customer by customer. In a world where brands chase trends, Narasimha focused on timelessness—offering high-quality designs, transparent pricing, and honest dealings. Customers didn't just walk in for ornaments—they came in for peace of mind.",

        "One of the most impressive aspects of Mukunda Jewellers' growth is the community built along the way. Today, the brand employs over 450 individuals, many of whom have been with the company for years. They aren't just workers—they're part of the Mukunda family. Narasimha's leadership style is rooted in mentorship. He doesn't just hire talent—he nurtures it.",

        "What makes Narasimha Reddy's story truly remarkable is when it began. He didn't rise in his 20s, nor did he inherit a generational business. He built everything later in life—at a stage when most would hesitate to start over. But Narasimha proves that age is never a barrier when the dream is real. With life experience came clarity. With maturity came stability.",

        "Mukunda Jewellers today is more than a business empire—it's a legacy. It's a testament to what can happen when someone refuses to give up, no matter their age, no matter the odds. So here's to Narasimha Reddy—who proved, once again, that grit shines brighter than gold and age is just a number when belief is boundless."
      ],
      quote: "Age is never a barrier when the dream is real and belief is boundless.",
      hashtags: ["#MukundaJewellers", "#AgeIsJustANumber", "#BusinessSuccess", "#Legacy", "#ManamuMedia"]
    }
  },
    , {
    id: 'pawan-kumar',
    name: 'Pavan Kumar',
    title: 'From Government Job to Crore Club',
    oneLiner: 'Building a ₹3 crore beverage empire with Desi Chai & BBC Café',
    excerpt: "Pavan Kumar's journey from a secure government job to building a thriving beverage empire shows that success isn't about safety—it's about seizing opportunities. His brands now serve over ₹25 lakhs monthly through innovative systems and authentic experiences...",
    image: '/Images/Pavan-Kumar.jpg',
    thumbnail: '/Images/Pavan-Kumar.jpg',
    stats: {
      revenue: '₹3 Crore Annual',
      impact: '₹25L Monthly'
    },
    size: 'large',
    achieverId: 'custom-9',
    fullStory: {
      title: "From Government Job to Crore Club: Pavan Kumar's Bold Brew of Business Success",
      highlightPhrase: "From safety to success. From chai to crores.",
      story: [
        "In a country where a government job is often seen as the ultimate symbol of security and success, few dare to step off the beaten path. But Pavan Kumar did just that—and brewed something extraordinary. Today, he is the force behind Desi Chai, BBC Café, and South Indian Filter Coffee, collectively serving over ₹25 lakhs a month, raking in a staggering ₹3 crore annually.",

        "His journey is a bold reminder that success isn't always about safety—it's about sensing the right opportunity, taking the leap, and brewing your dream with confidence.",

        "Pavan Kumar's story begins like many others—he held a secure government position, with a stable paycheck, routine life, and societal approval. But within him stirred a passion for doing something bigger. He wasn't content with comfort. He wanted creation. He wanted connection.",

        "One thing he noticed everywhere he went was the enduring love people had for chai. From roadside stalls to corporate offices, chai wasn't just a drink—it was an emotion. But despite the demand, the market lacked consistency, experience, and brand value.",

        "Armed with courage and a deep understanding of local tastes, Pawan launched Desi Chai—a brand that felt familiar, flavorful, and rooted in nostalgia. Unlike boutique cafés that leaned into westernized menus, Desi Chai served the comfort of home: kadak chai, masala chai, elaichi chai, and more.",

        "With Desi Chai gaining traction, Pawan expanded his vision. He launched BBC Café—a vibrant café concept that merged quick service with Indian flavors, perfect for urban youth. Alongside it, came the third pillar: South Indian Filter Coffee, a brand dedicated to authentic, robust filter coffee served with traditional flair.",

        "What makes Pawan's success sustainable isn't just great tea or coffee—it's his approach to business. He built strong back-end systems, invested in training, created standardization across outlets, and focused on franchise-friendly models. This structure allowed him to scale rapidly without losing quality.",

        "From government employee to employer of hundreds, he's created jobs, empowered youth, and helped others build income through his franchise models. Today, his brands are expanding across states, with interest from tier 1 cities, airports, and high-footfall zones.",

        "At Manamu Media, we celebrate real stories—stories that stir, stories that serve, and stories that shine. Pavan Kumar is proof that real success starts with a brave decision. He gave up a government chair and picked up a kettle—and in doing so, he poured himself into a legacy."
      ],
      quote: "Success isn't always about safety—it's about sensing the right opportunity and brewing your dream with confidence.",
      hashtags: ["#DesiChai", "#BBCCafe", "#BusinessSuccess", "#Entrepreneurship", "#ManamuMedia"]
    }
  },
    {
    id: 'sahithi-chiluveru',
    name: 'Sahithi Chiluveru',
    title: 'From Software to Spice',
    oneLiner: 'Building ₹1 crore pickle empire while empowering women',
    excerpt: "Sahithi Chiluveru transitioned from tech to tradition, transforming her passion for Telugu pickles into a ₹1 crore business while creating opportunities for women artisans. Her brand Flavours of Telugu combines heritage recipes with modern entrepreneurship.",
    image: '/Images/sahithi chiluveru.jpg',
    thumbnail: '/Images/sahithi chiluveru.jpg',
    stats: {
      revenue: '₹1 Crore Revenue',
      impact: 'Women Empowerment'
    },
    size: 'large',
    achieverId: 'custom-8',
    fullStory: {
      title: "From Software to Spice: Sahithi Chiluveru's ₹1 Crore Telugu Pickles Success Story",
      highlightPhrase: "Tech to Taste Transformation",
      story: [
        "Meet Sahithi Chiluveru, a former software professional who swapped code for condiments, building a ₹1 crore pickle empire while preserving Telugu culinary heritage. Her journey from IT corridors to artisan kitchens proves that tradition and entrepreneurship can create powerful synergies.",

        "While successful in her tech career, Sahithi felt a growing urge to preserve her family's traditional pickle recipes. What began as weekend kitchen experiments soon revealed a market gap for authentic, preservative-free Telugu pickles with modern packaging and distribution.",

        "Flavours of Telugu was born from this intersection of heritage and innovation. Sahithi combined grandmother's recipes with food safety certifications, eye-catching branding, and e-commerce platforms. Her unique value proposition: Homemade taste with professional consistency.",

        "The real breakthrough came through community empowerment. Sahithi built a network of women artisans, training them in standardized production while preserving traditional methods. This not only ensured recipe authenticity but also created sustainable livelihoods.",

        "Key strategies included: Leveraging social media to showcase the artisanal process, creating gift packs for urban millennials, and participating in food expos. Within 3 years, Flavours of Telugu became synonymous with premium regional condiments, supplying to 15+ states and 3 countries.",

        "Today, Sahithi's venture stands as a ₹1 crore testament to cultural entrepreneurship, employing 45+ women and preserving 22 traditional recipes. Her story demonstrates how passion projects can scale into successful businesses while creating social impact."
      ],
      quote: "Follow your passion and empower others along the way - success becomes more meaningful when it lifts others up.",
      hashtags: [
        "#TeluguPickles",
        "#WomenEntrepreneurship",
        "#TechToTaste",
        "#EmpowerWomen",
        "#CulturalEntrepreneur",
        "#ManamuMedia"
      ]
    }
  },
    {
    id: 'naveen-mudaliar',
    name: 'Naveen Mudaliar',
    title: 'From Struggle to Success',
    oneLiner: 'From financial struggles to mall ownership',
    excerpt: "Naveen Mudaliar's life changed drastically when he turned his financial struggles into opportunities. Today, he is the proud owner of multiple malls and continues to inspire aspiring entrepreneurs with his unwavering determination...",
    image: '/Images/naveen.jpg',
    thumbnail: '/Images/naveen.jpg',
    stats: {
      impact: 'Mall Owner',
      partners: 'Multiple Ventures'
    },
    size: 'large',
    achieverId: 'custom-7', // Linked to Anuja Prabhakar
    fullStory: {
      title: "From Struggle to Success: Naveen Mudaliar's Journey to Mall Ownership",
      highlightPhrase: "Struggle to Success",
      story: [
        "Meet Naveen Mudaliar, a 29-year-old entrepreneur who turned his hardships into stepping stones for success. From facing financial struggles to becoming a mall owner, his inspiring journey showcases the power of resilience, vision, and unwavering determination.",

        "Naveen's entrepreneurial journey was not an easy one. Like many aspiring business owners, he faced financial constraints, market challenges, and societal pressures. But instead of giving up, he took each obstacle as an opportunity to learn and grow. With a strong will to succeed, he started small, exploring various business ventures before finding his niche in the retail and real estate sector.",

        "With a keen sense of business and the ability to identify opportunities, Naveen worked tirelessly to build his empire. His sharp decision-making and customer-centric approach allowed him to expand his business step by step. His dedication led him to own and operate a successful mall, making him a well-recognized name in the industry.",

        "Today, Naveen is not just a mall owner—he is a symbol of perseverance and success. His journey teaches aspiring entrepreneurs that challenges are stepping stones to growth, a clear vision and hard work can transform any dream into reality, and building strong relationships and a customer-first approach lead to sustainable success.",

        "Naveen's story serves as motivation for young entrepreneurs who dare to dream big. His transformation from struggles to owning a mall proves that with determination, smart decisions, and an unbreakable spirit, success is inevitable."
      ],
      quote: "Challenges are not obstacles but stepping stones that lead to unexpected heights of success.",
      hashtags: ["#MallOwner", "#Entrepreneur", "#FromStruggleToSuccess", "#Inspiration", "#ManamuMedia"]
    }
  },
    {
    id: 'satish',
    name: 'Satish',
    title: 'From Cart to Crores',
    oneLiner: 'Building a ₹3 crore food empire from a humble cart',
    excerpt: "Brother Satish transformed a simple street cart serving Telugu fish curry into Poruginti Chepala Pulusu, now a ₹3 crore food brand. His journey from humble beginnings to culinary success showcases the power of authenticity and perseverance...",
    image: '/Images/Satish.jpg',
    thumbnail: '/Images/Satish.jpg',
    stats: {
      revenue: '₹3 Crore Revenue',
      impact: '30+ Employees'
    },
    size: 'large',
    achieverId: 'custom-6',
    fullStory: {
      title: "From Cart to Crores: Brother Satish's Legacy of Flavor and Fire",
      highlightPhrase: "Cart to Crores",
      story: [
        "In the bustling streets where dreams often remain unspoken, Brother Satish began his journey with nothing but a cart and an unwavering belief in the power of authentic Telugu cuisine. Today, his brand Poruginti Chepala Pulusu stands as a ₹3 crore testament to the magic that happens when passion meets perseverance.",

        "The story began with a simple observation: the lack of authentic, home-style Telugu food in local eateries. Armed with traditional recipes and minimal savings, Satish set up a modest street cart, specializing in chepala pulusu (fish curry). The name 'Poruginti Chepala Pulusu' (The Neighbor's Fish Curry) wasn't just clever branding—it embodied the warmth and familiarity he wanted to serve.",

        "Early days brought their share of challenges. Rain or shine, Satish would be there, cooking and serving with unwavering dedication. While footfall was initially slow, those who tasted his curry became instant loyalists. His secret? An uncompromising commitment to quality and authenticity. Every ingredient was carefully sourced, every spice precisely measured, and every dish cooked with the same care as if it were being served at home.",

        "As word spread, his small cart began drawing crowds from across the city. People weren't just coming for a meal—they were coming for a taste of tradition, served with pride and perfection. This growing customer base enabled Satish to dream bigger, leading to the opening of his first permanent restaurant.",

        "The transition from street vendor to restaurant owner marked a new chapter, but Satish's core values remained unchanged. The same authentic flavors that won hearts on the streets were now being served in a proper dining space. His hands-on approach, personal attention to quality, and connection with customers continued to be the cornerstone of his success.",

        "Today, Poruginti Chepala Pulusu has evolved into a ₹3 crore business, employing over 30 people and supporting numerous local suppliers. The brand has become more than just a restaurant—it's a cultural landmark that proves how traditional recipes, when served with passion and consistency, can create lasting impact.",

        "Beyond business success, Satish's journey has become a source of inspiration for aspiring entrepreneurs. He actively mentors others in the food industry, sharing insights gained from years of experience. His story demonstrates that starting small isn't a limitation—it's an opportunity to build something authentic and meaningful."
      ],
      quote: "Success isn't about overnight transformation—it's about showing up every day, serving with love, and believing in the power of authentic flavors.",
      hashtags: ["#FoodEntrepreneur", "#TeluguCuisine", "#SuccessStory", "#StartupJourney", "#ManamuMedia"]
    }
  },
    {
    id: 'vijaya-ramineni',
    name: 'Vijaya Ramineni',
    title: 'From Struggles to Success',
    oneLiner: 'The woman behind Mona Lisa Academy',
    excerpt: "Vijaya Ramineni overcame financial and societal hurdles to establish Mona Lisa Academy, now a premier institute for makeup and beauty skills that has trained hundreds of aspiring artists...",
    image: '/Images/Vijaya Ramineni.jpg',
    thumbnail: '/Images/Vijaya Ramineni.jpg',
    stats: {
      impact: 'Premier Beauty Academy',
      employeeCount: 'Trained 100s'
    },
    size: 'medium',
    achieverId: 'custom-5', // Linked to Mohan & Sushma Reddy
    fullStory: {
      title: "Vijaya Ramineni: From Struggles to Success – The Woman Behind Mona Lisa Academy!",
      highlightPhrase: "Struggles to Success",
      story: [
        "Meet Vijaya Ramineni, a woman of resilience and determination who turned her dreams into reality by founding Mona Lisa Academy. Her journey from challenges to triumph is a testament to hard work, perseverance, and an unbreakable spirit.",

        "Vijaya Ramineni's path to success was far from easy. Facing financial and societal hurdles, she never gave up on her passion for beauty and makeup artistry. Determined to create a platform where aspiring artists could learn and grow, she established Mona Lisa Academy, a premier training institute for professional makeup and beauty skills.",

        "Her journey was built on grit and innovation, allowing her to transform setbacks into stepping stones for success. Today, Mona Lisa Academy is a well-recognized institution that has trained hundreds of aspiring makeup artists, empowered women by providing them with career opportunities, and gained recognition as a top beauty academy.",

        "The secret to Vijaya's success lies in her unwavering passion, commitment to lifelong learning, focus on empowering others, persistence in the face of challenges, and dedication to building a brand with purpose and excellence.",

        "Vijaya Ramineni's journey is an inspiration to every woman with a dream. She has proven that passion, resilience, and dedication can lead to remarkable success."
      ],
      quote: "When passion meets persistence, challenges become mere stepping stones to success.",
      hashtags: ["#VijayaRamineni", "#SuccessStory", "#WomenEntrepreneurs", "#MonaLisaAcademy", "#MakeupArtist", "#Inspiration", "#ManamuMedia"]
    }
  },
    {
    id: 'sama-praveen-reddy',
    name: 'Sama Praveen Reddy',
    title: 'Transforming Careers with findHR',
    oneLiner: 'Revolutionizing job market with real-time HR support',
    excerpt: "Sama Praveen Reddy is revolutionizing the job market with findHR, an app connecting job seekers with real-time HR experts. His innovative approach has helped thousands find the right career opportunities...",
    image: '/Images/sama praveen.jpg',
    thumbnail: '/Images/sama praveen.jpg',
    stats: {
      impact: 'Innovative HR Tech',
      partners: 'Thousands Connected'
    },
    size: 'small',
    achieverId: 'custom-4', // Linked to Vikram Aditya
    fullStory: {
      title: "Sama Praveen Reddy: Transforming Careers with findHR",
      story: [
        "Meet Sama Praveen Reddy, an innovative entrepreneur from Hyderabad, revolutionizing the job market with findHR—an app that connects job seekers with real-time HR experts through chat, voice, or video calls. His vision is to simplify and personalize job searching, providing on-demand career support for professionals and businesses alike.",

        "Recognizing the challenges job seekers face—lack of guidance, unreliable job listings, and difficulty in accessing HR professionals—Sama Praveen Reddy set out to create a solution that bridges the gap between job seekers and industry experts. findHR is designed to offer personalized career advice in real-time, provide resume building and interview coaching, and connect businesses with reliable, skilled talent.",

        "With findHR, users no longer need to navigate the job market alone. The app has already helped thousands of professionals find the right job opportunities faster, gain expert HR insights for career growth, and receive immediate assistance for job applications and interviews.",

        "Sama Praveen Reddy's success can be attributed to identifying a crucial need in the market, leveraging technology effectively, providing real value to users, adapting to market trends, and maintaining a commitment to career growth for all.",

        "His journey proves that technology and innovation can reshape industries. findHR is not just an app—it's a game-changer, making career success achievable for everyone."
      ],
      quote: "Technology should make expertise accessible to everyone—that's how we transform not just careers, but lives.",
      hashtags: ["#SamaPraveenReddy", "#findHR", "#CareerSuccess", "#HRTech", "#JobSeekers", "#Entrepreneur", "#Innovation", "#ManamuMedia"]
    }
  },
    {
    id: 'ramya-nagendra',
    name: 'Ramya Nagendra',
    title: 'From ₹500 to ₹5 Crore',
    oneLiner: 'Turning ₹500 into a ₹5 crore fashion empire',
    excerpt: 'Ramya Nagendra started her business with just ₹500. Her dedication and sharp business acumen have transformed her venture into a ₹5 crore fashion empire, setting an example for aspiring entrepreneurs...',
    image: '/Images/ramaya nagendar.jpg',
    thumbnail: '/Images/ramaya nagendar.jpg',
    stats: {
      revenue: '₹5 Crore Revenue',
      impact: 'Thriving Fashion Business'
    },
    size: 'large',
    achieverId: 'custom-3', // Linked to Rajesh Kumar
    fullStory: {
      title: "From ₹500 to ₹5 Crore: The Inspiring Journey of Ramya Nagendra",
      highlightPhrase: "₹500 to ₹5 Crore",
      story: [
        "Every great journey starts with a small step, and for Ramya Nagendra, it began with an unwavering belief in her abilities and an unshakable commitment to success. With limited financial resources but an abundance of ambition, she and her husband took their first steps into the world of business from Jagityal, Telangana.",

        "Starting a business with just ₹500 required immense resourcefulness. They began with a simple yet innovative idea, carefully identifying market demands and potential opportunities. With no luxury of large investments, every rupee was spent wisely, ensuring that their small venture was sustainable.",

        "Entrepreneurship is not just about starting a business; it is about overcoming obstacles and adapting to challenges. Ramya and her husband meticulously planned each stage of their journey, making strategic decisions that would eventually propel their business forward. Through smart investments, unwavering dedication, and sheer hard work, they scaled their business from a small venture into a multi-crore success story.",

        "Their growth wasn't overnight—it was the result of years of patience, continuous learning, and the ability to adapt to changing market trends. They faced financial struggles, supply chain difficulties, and market competition, but each challenge only made them stronger. By constantly innovating and offering value to their customers, they gained trust and expanded their brand presence.",

        "One of the key factors behind their success was their customer-centric approach. They focused on delivering high-quality products and services, ensuring that their customers remained loyal and satisfied. This not only helped in building a strong brand reputation but also led to exponential growth through word-of-mouth marketing.",

        "Ramya Nagendra's entrepreneurial journey teaches us several valuable lessons: Start Small, Dream Big – Every successful business starts with a single step. What matters is the determination to keep going. Resilience is Key – Facing obstacles is a part of the journey, but overcoming them is what sets successful entrepreneurs apart. Smart Investments Matter – Making wise financial decisions can turn even a small investment into a massive success.",

        "The Manamu Foundation extends heartfelt congratulations to Ramya Nagendra and her husband for setting new benchmarks in the entrepreneurial world. Their journey is proof that financial limitations are no barrier when armed with vision, commitment, and resilience."
      ],
      quote: "Financial limitations are no barrier when armed with vision, commitment, and resilience.",
      hashtags: ["#500To5Crore", "#WomenEntrepreneurs", "#TelanganaPride", "#BusinessSuccess", "#ManamuFoundation"]
    }
  },

    {
    id: 'ca-althaf',
    name: 'CA Althaf',
    title: 'From Dreamer to Achiever',
    oneLiner: 'Transforming 10K+ students with education',
    excerpt: "CA Althaf has transformed the lives of over 10,000 students through his dedication to education. As a mentor and author, he continues to inspire aspiring chartered accountants to achieve their dreams...",
    image: '/Images/CA althaf.jpg',
    thumbnail: '/Images/CA althaf.jpg',
    stats: {
      impact: 'Mentor to 10K+',
      partners: 'Published Author'
    },
    size: 'medium',
    achieverId: 'custom-2', // Added link to Divya Sharma (education focus)
    fullStory: {
      title: "From Dreamer to Achiever: Meet CA Althaf",
      story: [
        "Meet CA Althaf, an inspiring figure who has transformed the lives of 10K+ students with his unwavering dedication to education and success. From humble beginnings to becoming a mentor, author, and role model, his journey is a testament to perseverance and passion.",

        "Driven by the dream of excelling in the field of Chartered Accountancy, CA Althaf overcame numerous challenges to achieve his goals. His story is not just about personal success but about empowering thousands of students to chase their dreams fearlessly.",

        "Through his expertise and mentorship, CA Althaf has guided 10K+ students on their CA journey, authored insightful resources to simplify learning, motivated aspiring professionals to never give up, and instilled confidence in students striving for excellence.",

        "His success teaches important lessons: dream big, never give up, empower others, keep learning, and believe in yourself. CA Althaf's journey is a reminder that persistence, knowledge, and dedication can turn dreams into reality. His impact continues to grow, inspiring future generations to achieve their aspirations."
      ],
      quote: "Success is not just about what you achieve, but how many lives you positively impact along the way.",
      hashtags: ["#DreamBig", "#CAJourney", "#Inspiration", "#KeralaPride", "#TeacherOf10K", "#AuthorLife", "#NeverGiveUp", "#SuccessStory"]
    }
  },
    {
    id: 'ashraf-ali',
    name: 'Ashraf Ali',
    title: 'Transforming the Salon Industry',
    oneLiner: 'Redefining salon experiences with Aniq Studio Salon',
    excerpt: "Ashraf Ali's journey from a small-town entrepreneur to the founder of Aniq Studio Salon is nothing short of inspiring. With a clear vision and dedication, he redefined the salon industry, creating a premium experience for customers...",
    image: '/Images/ashraf ali.jpg',
    thumbnail: '/Images/ashraf ali.jpg',
    stats: {
      employeeCount: '350 Employees',
      partners: '85 Strategic Partners'
    },
    size: 'medium',
    achieverId: 'custom-1', // Linked to Arjun Singh
    fullStory: {
      title: "Transforming the Salon Industry: The Inspirational Journey of Ashraf Ali",
      highlightPhrase: "Transforming the Salon Industry",
      story: [
        "Meet Ashraf Ali, a 28-year-old visionary entrepreneur who is revolutionizing the salon industry in South India. As the founder of Aniq Studio Salon, he has built a thriving brand with over 350 employees and 85 strategic partners, redefining beauty and wellness services across the region.",

        "Ashraf Ali started his entrepreneurial journey with a simple yet powerful vision: to elevate the salon experience by combining world-class services with innovation and professionalism. With a keen understanding of the beauty industry and a drive to make a difference, he set out to create a premium salon chain that offers more than just grooming services.",

        "Despite facing numerous challenges—including financial constraints, market competition, and the need to build brand trust—Ashraf remained focused on his goal. He worked tirelessly to establish a salon brand that prioritizes quality, customer satisfaction, and industry-leading expertise.",

        "Today, Aniq Studio Salon stands as a game-changer in the beauty industry, thanks to Ashraf's commitment to excellence. The brand is known for premium and personalized salon services, a strong team of skilled professionals trained to deliver top-tier beauty and wellness solutions, and collaboration with top stylists and brands to bring the latest trends to South India.",

        "Under his leadership, Aniq Studio has become synonymous with luxury, innovation, and customer-first service, setting a benchmark for others in the industry. Expanding across multiple locations, has made high-quality beauty services accessible to a wider clientele.",

        "Ashraf Ali's journey offers valuable lessons for aspiring entrepreneurs: Start with a clear vision – Success begins with a well-defined goal and the determination to achieve it. Resilience is key – Facing challenges is inevitable, but overcoming them is what defines a true entrepreneur. Prioritize quality and customer satisfaction – A business thrives when it builds trust and offers value to its customers."
      ],
      quote: "Success begins with a well-defined goal and the determination to achieve it, no matter the obstacles.",
      hashtags: ["#EntrepreneurSuccess", "#SalonIndustry", "#AniqStudio", "#SouthIndia", "#YoungEntrepreneurs"]
    }
  },









,

,












];

// Add the function to get success stories by achiever ID
export const getSuccessStoriesByAchiever = (achieverId: string): SuccessStoryData[] => {
  return successStories.filter(story => story.achieverId === achieverId);
};
